import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 20,
  pageOptions: [20, 50, 100],
  totalRows: 1,
  sortOptions: [],
  ProjectOptions: [],
  fields: [
    { key: 'name', label: 'name' },
    { key: 'photo', label: 'photo' },
    { key: 'email', label: 'email' },
    { key: 'is_email_verified', label: 'is_email_verified' },
    { key: 'last_ip_address', label: 'last_ip_address' },
    { key: 'last_ip_address_access', label: 'last_ip_address_access', sortable: true },
    { key: 'last_phone_access', label: 'last_phone_access', sortable: true },
    { key: 'created_at', label: 'created_at', sortable: true },
    { key: 'updated_at', label: 'updated_at', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action' },
  ],
  items: [],
})

// getters
const getters = {}

// actions
const actions = {
  getProject({ commit }) {
    const param = { status: 'account/projects' }
    useIPA.get(param).then(response => {
      const user = {
        rows: response.data.data,
      }
      commit('setProject', { ...user })
    })
  },
  setProject({ commit }, obj) {
    return new Promise((resolve, reject) => {
      const rawData = {
        project_id: obj,
      }
      const param = { rawData, url: 'internal/auth/set/project', id: null }
      useIPA.postput(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
            console.log(response.data.data.token)
            localStorage.setItem('accessToken', response.data.data.token)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  getAll({ commit }, params) {
    const param = { status: 'master/users', params }
    useIPA.get(param).then(response => {
      const user = {
        rows: response.data.data,
      }
      const { pagination } = response.data
      commit('setData', { ...user })
      commit('setPagination', pagination)
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/user/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPut({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        company_id: formData.company,
        projects: formData.projects,
        role_id: formData.select_2,
        name: formData.text_1,
        email: formData.text_2,
        password: formData.text_3,
        phone: formData.text_4,
      }
      const param = { rawData, url: 'internal/master/user', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'data-user' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if ('hasErrors' in error.response.data) {
            reject(error.response.data.message)
          } if ('error' in error.response.data) {
            reject(error.response.data.error)
          } else {
            reject(error.message)
          }
        })
    })
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/user', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
}

// mutations
const mutations = {
  setData(state, user) {
    state.items = user.rows
    state.totalRows = user.rows.length
  },
  setProject(state, data) {
    state.ProjectOptions = []
    for (let i = 0; i < data.rows.length; i++) {
      data.rows[i].projects = {
        ...data.rows[i].projects,
        value: data.rows[i].projects.id,
        title: data.rows[i].projects.name,
      }
      const option = data.rows[i].projects
      state.ProjectOptions.push({ ...option })
    }
  },
  setPagination(state, pagination) {
    state.perPage = pagination.limit
    state.totalRows = pagination.total_items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
